import { AspError } from "./errors.js";

export function appendOptionalArtifactFields(
  body: Record<string, unknown>,
  fields: { artifactId?: string; version?: string; repoUrl?: string },
): Record<string, unknown> {
  if (fields.artifactId) body.artifact_id = fields.artifactId;
  if (fields.version) body.version = fields.version;
  if (fields.repoUrl) body.repo_url = fields.repoUrl;
  return body;
}

export function looksLikeSubmissionId(id: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
}

export function assertSubmissionId(id: string, exampleCommand: string): void {
  if (looksLikeSubmissionId(id)) return;
  throw new AspError(`Invalid submission ID: ${id}`, {
    code: "INVALID_REQUEST",
    hint: `Use submission_id from publish output, not plugin/skill id. Example: ${exampleCommand}`,
  });
}
